module.exports = __webpack_public_path__ + "media/images/flags/4x3/deu-e5316adebc2d6f79fe395ed289026d0f.svg";